import type { Player } from '@lottiefiles/react-lottie-player';
import { PlayerEvent } from '@lottiefiles/react-lottie-player';
import { useMediaQuery } from '@mui/material';
import isChromatic from 'chromatic/isChromatic';
import { useCallback, useRef } from 'react';

import {
  DEFAULT_ANIMATION_SPEED,
  REDUCED_MOTION_FRAME_MAP,
} from './ChkLottieAnimation.constants';
import type { ChkAnimationType } from './ChkLottieAnimation.types';

export const useLottieAnimationPrefersReducedMotion = (
  src: ChkAnimationType
) => {
  const playerRef = useRef<Player>(null);
  const prefersReducedMotion = useMediaQuery(
    '(prefers-reduced-motion: reduce)'
  );
  const speed = getSpeed(prefersReducedMotion);

  const handleEvent = useCallback(
    (event: PlayerEvent) => {
      if (
        event === PlayerEvent.Load &&
        (isChromatic() || prefersReducedMotion)
      ) {
        const totalFramesCount =
          playerRef.current?.state.instance?.totalFrames ?? 1;

        const frameConfig = REDUCED_MOTION_FRAME_MAP.get(src);
        let targetFrame = totalFramesCount - 1;

        if (frameConfig && frameConfig < 1) {
          targetFrame = Math.floor(totalFramesCount * frameConfig);
        }

        playerRef.current?.setSeeker(targetFrame, false);
      }
    },
    [prefersReducedMotion, src]
  );

  return {
    playerRef,
    handleEvent,
    speed,
  };
};

function getSpeed(prefersReducedMotion: boolean) {
  if (!prefersReducedMotion) {
    return DEFAULT_ANIMATION_SPEED;
  }

  // Speed doesn't matter when animation is stopped, but we return default for consistency
  return DEFAULT_ANIMATION_SPEED;
}
